// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"49b3f3a8","977":"54621a2d"}[chunkId] + ".chunk.js";
};